// eslint-disable-next-line no-unused-vars
import { StatsLeadersState } from '../types';
// eslint-disable-next-line no-unused-vars
import { StatsLeadersStatsType } from '../../types';
import { normalizeStatsLeaders } from '../normalizr/normalize-stats-leaders';

/**
 * @typedef {object} Payload
 * @property {StatsLeadersStatsType} type
 * @property {object} data
 */

/**
 * @param {StatsLeadersState} draft - Draft state.
 * @param {Payload} payload - Action payload.
 */
export const setStatsLeaders = (draft, payload) => {
    const { type, data } = payload;

    const { entities, result } = normalizeStatsLeaders(data);

    draft.keys[type][result.search.context.identifier] = {
        players: result.players
    };

    draft.values = {
        stats: mergeObjects(draft.values.stats ?? {}, entities.stats),
        teams: {
            ...draft.values.teams,
            ...entities.teams
        },
        players: {
            ...draft.values.players,
            ...entities.players
        }
    };
};

const mergeObjects = (existingData, newData) => {
    if (!newData) {
        return existingData;
    }

    /**
     * @param {[string, object]} newDatum -
     * @returns {[string, object]} x
     */
    const merge = (newDatum) => {
        const [key, value] = newDatum;

        return [
            key,
            {
                ...(existingData[key] ?? {}),
                ...value
            }
        ];
    };

    const mergedEntries = Object.entries(newData).map(merge);

    return {
        ...existingData,
        ...Object.fromEntries(mergedEntries)
    };
};
